export enum UserSettingsKeys {
  tableAutoRefreshOnImport = 'tableAutoRefreshOnImport',
  documentNotifications = 'documentNotifications',
  pdfTronSignatures = 'pdfTronSignatures',
  documentEncryption = 'documentEncryption',
  faxTransmissionReports = 'fax_status_report'
}

export enum AccountSettingsKeys {
  permanentDeletion = 'permanent_deletions',
  hideOutboxes = 'hide_outboxes',
  requireTwoFactor = 'require_two_factor',
  encryptionBeta = 'encryption_beta',
  destinations = 'destinations'
}
